import React__default from "react";
import { useLatestValue as s } from "./use-latest-value.js";
let o = function(t) {
  let e = s(t);
  return React__default.useCallback((...r) => e.current(...r), [e]);
};
export {
  o as useEvent
};
